<template>
    <h2 class="page-sub-header">Construction Code AI Assistant - Terms of Service</h2>
    <p class="last-updated">Last Updated: February 5th, 2025</p>

    <section>
      <h3>1. Who Can Use Construction Code AI Assistant</h3>
      <p>Construction Code AI Assistant is available to anyone with access to the Apple App Store or Google Play Store. Our app is rated <strong>4+ on iOS</strong>, meaning it is suitable for all users.</p>
    </section>

    <section>
      <h3>2. Subscription & Payments</h3>
      <ul>
        <li>All payments and subscriptions are <strong>handled through the Apple App Store and Google Play Store</strong>.</li>
        <li>Refunds, cancellations, and billing inquiries must be directed to <strong>Apple or Google</strong>, as we <strong>do not process payments directly</strong>.</li>
        <li>When your <strong>subscription expires</strong>, your access to the app and its data sources <strong>immediately ends</strong>. Saved conversations and bookmarks will be inaccessible until you renew.</li>
      </ul>
    </section>

    <section>
      <h3>3. AI Guidance & Liability Disclaimer</h3>
      <ul>
        <li>Construction Code AI Assistant provides <strong>AI-powered responses based on publicly available construction codes</strong>.</li>
        <li><strong>These responses are for informational purposes only</strong> and are <strong>not a substitute for professional advice</strong> from a licensed contractor, inspector, or engineer.</li>
        <li>We recommend <strong>verifying AI-generated answers</strong> with official regulatory sources or professionals before making decisions.</li>
        <li><strong>You assume full responsibility</strong> for any actions taken based on the app’s responses. We are <strong>not liable for any damages, penalties, or compliance issues</strong> resulting from the use of Construction Code AI Assistant.</li>
      </ul>
    </section>

    <section>
      <h3>4. Account Management & Data Privacy</h3>
      <ul>
        <li>Your <strong>email and password are securely stored via AWS Cognito</strong>.</li>
        <li><strong>We do not sell, share, or store any unnecessary personal data</strong>.</li>
        <li>If you wish to <strong>delete your account</strong>, you can submit a request from the Profile screen.</li>
        <li><strong>Warning:</strong> Deleting your account is <strong>permanent</strong>. This action will <strong>erase all data associated with your account</strong>, including saved conversations and bookmarks. <strong>Once deleted, this data cannot be recovered.</strong></li>
        <li>You will receive a confirmation prompt before finalizing the deletion to ensure you intend to proceed.</li>
      </ul>
    </section>

    <section>
      <h3>5. Analytics & Tracking</h3>
      <ul>
        <li>We use <strong>Firebase Analytics</strong> to improve app functionality and user experience.</li>
        <li><strong>No personally identifiable information is collected through analytics</strong>.</li>
        <li>Currently, users <strong>cannot disable analytics tracking</strong>, but we may offer this option in the future.</li>
      </ul>
    </section>

    <section>
      <h3>6. Updates to These Terms</h3>
      <p>We may update these Terms of Service to reflect changes in our app, features, or legal requirements. Users will be notified <strong>via an in-app message or update to this page</strong>.</p>
    </section>

    <p class="thank-you">Thank you for using Construction Code AI Assistant!</p>
</template>

<script>
export default {
  name: "CodeAuthorityTerms",
};
</script>